<template>
  <v-container v-scroll="onScroll" fluid class="pt-0">
    <v-card flat tile color="var(--v-cards-base)">
      <div class="toolbar-container" ref="subheader" :class="{ 'subheader-hidden': subheaderHidden }" v-if="contextTitle.length > 2 && contextHelpPathPrefix">
        <v-container class="bg-surface-variant m-0 p-0" fluid>
          <v-row no-gutters>
            <v-col
              class="d-inline-flex align-center"
              cols="12"
              lg="9"
              md="8"
              sm="12"
            >
              <v-toolbar-title class="subtitle-2 mr-5">
                <v-breadcrumbs :items="contextTitle" active-class="black--text" large>
                </v-breadcrumbs>
              </v-toolbar-title>
              <portal-target name="destination" />
            </v-col>
            <v-col
              class="d-inline-flex align-center justify-md-end justify-sm-start pa-2"
              cols="12"
              lg="3"
              md="4"
              sm="12"
            >
            <portal to="destination" :disabled="portalToolbarStatusDisabled">
              <v-toolbar-items class="pl-2">
                <slot name="badges"></slot>
              </v-toolbar-items>
            </portal>
            <div class="d-inline-flex align-center" :class="{ 'ml-auto' : portalToolbarStatusDisabled}">
              <v-toolbar-title class="subtitle-2 mr-3 mb-1">
                <p class="black--text pt-5 pl-5" v-if="contextHelpPathPrefix">{{contextHelpPathPrefix}}</p>
              </v-toolbar-title>
              <v-btn icon :href="contextHelpPath" target="_blank" class="mr-xs-2 mr-md-4">
                <v-icon color="primary" size=30>mdi-help-circle</v-icon>
              </v-btn>
            </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <div class="toolbar-container" ref="subheader" :class="{ 'subheader-hidden': subheaderHidden }" v-else>
        <v-container class="bg-surface-variant m-0 p-0" fluid>
          <v-row no-gutters>
            <v-col
              class="d-inline-flex align-center"
            >
              <v-toolbar-title class="subtitle-2 mr-5">
                <v-breadcrumbs :items="contextTitle" active-class="black--text" large>
                </v-breadcrumbs>
              </v-toolbar-title>
              <v-toolbar-items class="pl-2">
                <slot name="badges"></slot>
              </v-toolbar-items>
              <div class="d-inline-flex align-center ml-auto mr-4">
                <v-toolbar-title class="subtitle-2 mr-3 mb-1">
                  <p class="black--text pt-5 pl-5" v-if="contextHelpPathPrefix">{{contextHelpPathPrefix}}</p>
                </v-toolbar-title>
                <v-btn icon :href="contextHelpPath" target="_blank" class="mr-xs-2 mr-md-4">
                  <v-icon color="primary" size=30>mdi-help-circle</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <v-progress-linear v-if="showLoader" class="ma-0" :class="{ 'p-fixed': subheaderHidden }" color="primary" height=15 indeterminate/>
    </v-card>
      <v-row align="center" justify="center" v-bind:class="{'px-2': noGutters === false, 'px-0': noGutters === true}">
        <v-col cols=12 xs=12 sm=12 md=12 :lg="contextWidth" :xl="contextWidth" class="py-0">
        <v-alert class="rounded-0 mb-0 mt-3" prominent :type="notificationVariant" transition="scale-transition" :value="showNotification">
          <v-row align="center">
            <v-col class="grow">
              <span v-html="notificationText"></span>
            </v-col>
            <v-col class="shrink">
              <v-btn icon @click="closeNotification"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>
        </v-alert>
        </v-col>
      </v-row>
      <v-row align="center" justify="center" v-bind:class="{'px-2': noGutters === false, 'px-0': noGutters === true}" v-if="emptyContent && !missingData">
        <v-col cols=12 xs=12 sm=12 md=12 :lg="contextWidth" :xl="contextWidth" :class="{enableBlur: showLoader}">
          <slot></slot>
        </v-col>
      </v-row>
      <v-row align="center" justify="center" v-bind:class="{'px-2': noGutters === false, 'px-0': noGutters === true}" v-else-if="!missingData">
        <v-col cols=12 xs=12 sm=12 md=12 :lg="contextWidth" :xl="contextWidth">
          <v-card outlined class="rounded-sm card-border" color="var(--v-cards-base)">
            <v-card-text :class="{'pa-0': noGutters === true, enableBlur: showLoader}" >
                <slot></slot>
            </v-card-text>
            <v-card-actions v-if="!noActions">
              <slot name="actions"/>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row align="center" justify="center" class="px-2" v-else>
        <v-col cols=12 xs=12 sm=12 md=12 :lg="contextWidth" :xl="contextWidth">
          <v-card outlined class="rounded-sm card-border" color="var(--v-cards-base)">
            <v-card-text :class="{enableBlur: showLoader}" >
              <v-alert class="rounded-sm mb-0" outlined text prominent type="error" transition="scale-transition" :value="missingData">
                <v-row align="center">
                  <v-col class="grow">
                    <span v-html="missingDataText"></span>
                  </v-col>
                </v-row>
              </v-alert>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    <div class="toolbar-footer" v-if="showFloater">
      <slot name="floater"></slot>
    </div>
  </v-container>
</template>

<script>
import Vue from 'vue'
import { EventBus } from '@/router/bus'

export default {
  name: 'context-page',
  data () {
    return {
      notificationVariant: null,
      notificationText: null,
      showNotification: false,
      missingData: false,
      missingDataText: null,
      contextTitle: [],
      subheaderHidden: false
    }
  },
  watch: {
    title (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.title) {
          const item = {
            text: this.title,
            disabled: true
          }
          if (this.titleRoute) {
            item.disabled = false
            item.href = this.titleRoute
          }
          if (Number(this.contextTitle.length) > Number(this.maxNumberOfSegments)) {
            const toRemove = Number(this.contextTitle.length) - Number(this.maxNumberOfSegments)
            this.contextTitle.splice(-toRemove, toRemove)
          }

          this.contextTitle.push(item)
        }
      }
    }
  },
  created () {
    EventBus.$on('reload-crumbs', () => {
      this.contextTitle = this.createPath()
    })
    this.contextTitle = this.createPath()
  },
  methods: {
    onScroll () {
      this.subheaderHidden = window.pageYOffset >= this.$refs.subheader?.$el?.offsetHeight
    },
    createPath () {
      // console.log(window.location.pathname)
      const contextPathItems = []
      var pathSegments = window.location.pathname.split('/')
      for (let index = 0; index < pathSegments.length; index++) {
        pathSegments[index] = decodeURIComponent(pathSegments[index])
      }
      if (this.numberOfLastSegmentsToRemove !== '0') {
        pathSegments.splice(-Number(this.numberOfLastSegmentsToRemove), Number(this.numberOfLastSegmentsToRemove))
      }
      if (Number(pathSegments.length) > Number(this.maxNumberOfSegments)) {
        const toRemove = Number(pathSegments.length) - Number(this.maxNumberOfSegments)
        pathSegments.splice(-toRemove, toRemove)
      }
      for (let i = 0; i <= pathSegments.length - 1; i++) {
        const contextPath = pathSegments[i] // .replace(/-/g, '')
        if (contextPath === '') {
          const dashItem = {
            text: this.$t('contextPath.dashboard'),
            href: '/dashboard'
          }
          contextPathItems.push(dashItem)
          continue
        }
        const itemText = this.$t('contextPath.' + contextPath)
        const item = {
          text: itemText.startsWith('contextPath.') ? contextPath : itemText,
          disabled: true
        }
        if (i === 1) {
          item.disabled = false
          item.href = this.baseRoute
        }

        const route = this.anonymousRoute ? this.anonymousRoute.filter(x => x.index === i)[0] : null
        if (route) {
          item.text = route.title ? route.title : item.text
          item.disabled = false
          item.href = route.route
        }

        contextPathItems.push(item)
      }
      if (this.title) {
        const item = {
          text: this.title,
          disabled: true
        }
        if (this.titleRoute) {
          item.disabled = false
          item.href = this.titleRoute
        }
        contextPathItems.push(item)
      }
      return contextPathItems
    },
    closeNotification () {
      this.showNotification = false
    }
  },
  computed: {
    contextWidth () {
      if (this.small) {
        return 6
      } else if (this.compact) {
        return 8
      } else if (this.large) {
        return 10
      }
      return 12
    },
    contextHelpPath () {
      if (this.alternativeRoute && this.alternativeRoute.length > 0) {
        return (
          Vue.$config.help_root +
          '/' +
          this.alternativeRoute +
          (this.tab ? '/' : '') +
          this.tab
        ).replaceAll('//', '/').replace(':/', '://')
      }
      return (
        Vue.$config.help_root +
        this.$route.path +
        (this.tab ? '/' : '') +
        this.tab
      ).replace(/([^:]\/)\/+/g, '$1')
    },
    portalToolbarStatusDisabled () {
      return this.$vuetify.breakpoint.xs
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    contextHelpPathPrefix: {
      type: String,
      default: ''
    },
    alternativeRoute: {
      type: String,
      default: ''
    },
    baseRoute: {
      type: String,
      default: ''
    },
    anonymousRoute: {
      type: Array,
      default: null
    },
    numberOfLastSegmentsToRemove: {
      type: Number,
      default: 0
    },
    maxNumberOfSegments: {
      type: Number,
      default: 10
    },
    tab: {
      type: String,
      default: ''
    },
    small: {
      type: Boolean,
      default: false
    },
    compact: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    noActions: {
      type: Boolean,
      default: false
    },
    noGutters: {
      type: Boolean,
      default: false
    },
    showLoader: {
      type: Boolean,
      default: false
    },
    showFloater: {
      type: Boolean,
      default: false
    },
    emptyContent: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" type="text/scss">
.context-help-header {
  cursor: pointer;
  opacity: 0.7;
  width: 28px;
  height: 28px;
  margin: 0px;
  &:hover {
    opacity: 1;
  }
}

.v-breadcrumbs__item {
  color: secondary !important;
}
.v-breadcrumbs__item--disabled {
  color: var(--v-caption-base) !important;
  font-weight: 500 !important;
}

.toolbar-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 52px;
  background-color: var(--v-toolbar-base);
}

.v-toolbar__title .v-breadcrumbs {
  padding: 0 26px;
}

.v-toolbar__title .v-breadcrumbs li:nth-child(2n) {
  padding: 0 8px;
}

.enableBlur {
  filter: blur(1.2px);
  pointer-events: none;
}

.subheader-hidden {
  visibility: hidden;
}

.v-progress-linear {
  z-index: 5;
}

.v-progress-linear.p-fixed {
    top: 40px !important;
}

.toolbar-footer {
  width: 100%;
  min-height: 56px;
  position: fixed;
  bottom: 0;
  z-index: 1;
  background-color: var(--v-toolbar-base);
}

</style>
